<!-- Consultancy Services -->
<ng-container
  class="!ml-[16px]"
  *ngIf="tenderType === 'consultancy services'; else constructionWork"
>
  <h3 class="header !text-[#21252A] font-semibold !mb-[0px] !pt-0 !ml-0">
    Consultancy Services
  </h3>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Project Management'"
      [label]="'Project Management'"
      [disable]="true"
      [richTextValue]="tendererResponse?.project_management"
    ></app-rich-textEditor>
    <!-- <app-uploaded-attachments
      [attachments] = "tendererResponse?.site_preparation_attach"
      [projectId] = "projectId"
      [modelType] = "'rfp_response'"
      [modelId] = "tendererResponse?.id"
    ></app-uploaded-attachments> -->
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Design Services'"
      [label]="'Design Services'"
      [disable]="true"
      [richTextValue]="tendererResponse?.design_services"
    ></app-rich-textEditor>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Cost Consultancy/Quantity Surveying:'"
      [label]="'Cost Consultancy/Quantity Surveying:'"
      [disable]="true"
      [richTextValue]="tendererResponse?.cost_consultancy"
    ></app-rich-textEditor>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Contract Administration'"
      [label]="'Contract Administration'"
      [disable]="true"
      [richTextValue]="tendererResponse?.contract_administration"
    ></app-rich-textEditor>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Risk Management and Feasibility Studies'"
      [label]="'Risk Management and Feasibility Studies'"
      [disable]="true"
      [richTextValue]="tendererResponse?.risk_management"
    ></app-rich-textEditor>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Ensure Sustainability and Compliance'"
      [label]="'Ensure Sustainability and Compliance'"
      [disable]="true"
      [richTextValue]="tendererResponse?.sustainability_compliance"
    ></app-rich-textEditor>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Final Inspection Sustainability and Compliance:'"
      [label]="'Final Inspection Sustainability and Compliance:'"
      [disable]="true"
      [richTextValue]="tendererResponse?.final_sustainability_compliance"
    ></app-rich-textEditor>
  </div>
</ng-container>

<!-- Construction Work -->
<ng-template #constructionWork>
  <h3 class="header !text-[#21252A] font-semibold !mb-[0px] !pt-0 !ml-0">
    Construction Work
  </h3>
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
    <app-rich-textEditor
      [label]="'Site Preparation'"
      [placeHolder]="'Site Preparation'"
      [disable]="true"
      [richTextValue]="tendererResponse?.site_preparation"
    ></app-rich-textEditor>

    <div
      class="flex items-center"
      *ngIf="sitePreparationAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of sitePreparationAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                sitePreparationAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                sitePreparationAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <!-- File Icon -->
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <!-- Attachment Name -->
            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>

    <app-rich-textEditor
      [label]="'Structural and Civil Works'"
      [placeHolder]="'Structural and Civil Works'"
      [disable]="true"
      [richTextValue]="tendererResponse?.structural_civil_works"
    ></app-rich-textEditor>
    <div
      class="flex items-center"
      *ngIf="structuralCivilWorksAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of structuralCivilWorksAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                structuralCivilWorksAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                structuralCivilWorksAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <!-- File Icon -->
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <!-- Attachment Name -->
            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>

    <app-rich-textEditor
      [label]="'MEP Works'"
      [placeHolder]="'MEP Works'"
      [disable]="true"
      [richTextValue]="tendererResponse?.mep_works"
    ></app-rich-textEditor>
    <div class="flex items-center" *ngIf="mepWorksAttachments?.length > 0">
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of mepWorksAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                mepWorksAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                mepWorksAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>

    <app-rich-textEditor
      [label]="'Finishing and Fit-Out'"
      [placeHolder]="'Finishing and Fit-Out'"
      [disable]="true"
      [richTextValue]="tendererResponse?.finishing_fitout"
    ></app-rich-textEditor>
    <div class="flex items-center" *ngIf="fitoutAttachments?.length > 0">
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of fitoutAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                fitoutAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                fitoutAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>

    <app-rich-textEditor
      [label]="'Health & Safety Compliance'"
      [placeHolder]="'Health & Safety Compliance'"
      [disable]="true"
      [richTextValue]="tendererResponse?.health_safety_compliance"
    ></app-rich-textEditor>
    <div class="flex items-center" *ngIf="healthSafetyAttachments?.length > 0">
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of healthSafetyAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                healthSafetyAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                healthSafetyAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>

    <app-rich-textEditor
      [label]="'Post-Construction Activities'"
      [placeHolder]="'Post-Construction Activities'"
      [disable]="true"
      [richTextValue]="tendererResponse?.post_construction_activities"
    ></app-rich-textEditor>
    <div
      class="flex items-center"
      *ngIf="postConstructionAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of postConstructionAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                postConstructionAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                postConstructionAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Technical Submission  -->
<ng-container class="!ml-[16px]">
  <h3 class="header !text-[#21252A] !font-semibold !mb-[0px] !pt-0 !ml-0 !pb-2">
    Technical Submission:
  </h3>

  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Technical Proposal'"
      [label]="'Technical Proposal'"
      [disable]="true"
      [richTextValue]="tendererResponse?.technical_proposal"
    ></app-rich-textEditor>
    <div
      class="flex items-center"
      *ngIf="technicalProposalAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of technicalProposalAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                technicalProposalAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                technicalProposalAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-4">
    <app-rich-textEditor
      [placeHolder]="'Project Programme'"
      [label]="'Project Programme'"
      [disable]="true"
      [richTextValue]="tendererResponse?.project_programme"
    ></app-rich-textEditor>
    <div
      class="flex items-center"
      *ngIf="projectProgrammeAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of projectProgrammeAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                projectProgrammeAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                projectProgrammeAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div
    class="flex items-center"
    *ngIf="cvsOfKeyPersonnelsAttachments?.length > 0"
  >
    <div
      class="text-[color:var(--Darkest-Grey,#21252A)] font-semibold font-roboto text-[14px] leading-normal"
    >
      CVs of Key Personnel

      <!-- Download attachment -->
      <div class="flex flex-col space-y-2">
        <a
          *ngFor="let attachment of cvsOfKeyPersonnelsAttachments"
          class="flex items-center space-x-2"
          [ngClass]="{
            'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
              cvsOfKeyPersonnelsAttachments,
            'text-black font-roboto text-[14px] font-normal leading-normal':
              cvsOfKeyPersonnelsAttachments
          }"
          #downloadTendererDocumentLink
          [href]="docUrl || '#'"
          (click)="
            downloadTendererDocument(
              $event,
              downloadTendererDocumentLink,
              attachment?.id,
              attachment?.path
            )
          "
        >
          <img
            [src]="getFileIcon(attachment)"
            alt="File Preview"
            class="object-cover w-5 h-5 cursor-pointer"
          />

          <span>{{ attachment?.name }}</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>
<!-- Relevant Experience -->
<ng-container class="">
  <h3
    class="header !text-[18px] !text-[#21252A] font-semibold !mb-[1rem] !pt-0 !ml-0"
  >
    Relevant Experience
  </h3>
  <!-- Relevant Experience  -->
  <div>
    <label class="!pt-[3px] !font-medium !mb-[1rem]">
      Relevant Experience 1
    </label>

    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 !mt-5">
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Client Name </mat-label>
            <input
              matInput
              [value]="
                experiences?.client_name_control1
                  ? experiences?.client_name_control1
                  : ''
              "
              readonly
              placeholder="Client Name"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Location </mat-label>
            <input
              matInput
              [value]="
                experiences?.location_control1
                  ? experiences?.location_control1
                  : ''
              "
              readonly
              placeholder="Location"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="p-0 mb-[1rem]">
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Project Description </mat-label>
          <textarea
            class=""
            matInput
            [value]="
              experiences?.project_description_control1
                ? experiences?.project_description_control1
                : ''
            "
            readonly
            placeholder="Project Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- Relevant Experience 2 -->
  <div class="!mt-5">
    <label class="!pt-[3px] !font-medium"> Relevant Experience 2 </label>

    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 !mt-5">
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Client Name </mat-label>
            <input
              matInput
              [value]="
                experiences?.client_name_control2
                  ? experiences?.client_name_control2
                  : ''
              "
              readonly
              placeholder="Client Name"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Location </mat-label>
            <input
              matInput
              [value]="
                experiences?.location_control2
                  ? experiences?.location_control2
                  : ''
              "
              readonly
              placeholder="Location"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="p-0 mb-[1rem] flex relative">
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem] w-full">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea
            class=""
            matInput
            [value]="
              experiences?.project_description_control2
                ? experiences?.project_description_control2
                : ''
            "
            readonly
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- Relevant Experience 3 -->
  <div class="!mt-5">
    <label class="!pt-[3px] !font-medium !mb-[1rem]">
      Relevant Experience 3
    </label>

    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 !mt-5">
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Client Name </mat-label>
            <input
              matInput
              [value]="
                experiences?.client_name_control3
                  ? experiences?.client_name_control3
                  : ''
              "
              readonly
              placeholder="Client Name"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Location </mat-label>
            <input
              matInput
              [value]="
                experiences?.location_control3
                  ? experiences?.location_control3
                  : ''
              "
              readonly
              placeholder="Location"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="p-0 mb-[1rem] flex relative">
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem] w-full">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea
            class=""
            matInput
            [value]="
              experiences?.project_description_control3
                ? experiences?.project_description_control3
                : ''
            "
            readonly
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div
    class="flex items-center"
    *ngIf="relevantExperienceAttachments?.length > 0"
  >
    <div
      class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
    >
      Attachments
      <!-- Download attachment -->
      <div class="flex flex-col space-y-2">
        <a
          *ngFor="let attachment of relevantExperienceAttachments"
          class="flex items-center space-x-2"
          [ngClass]="{
            'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
              relevantExperienceAttachments,
            'text-black font-roboto text-[14px] font-normal leading-normal':
              relevantExperienceAttachments
          }"
          #downloadTendererDocumentLink
          [href]="docUrl || '#'"
          (click)="
            downloadTendererDocument(
              $event,
              downloadTendererDocumentLink,
              attachment?.id,
              attachment?.path
            )
          "
        >
          <img
            [src]="getFileIcon(attachment)"
            alt="File Preview"
            class="object-cover w-5 h-5 cursor-pointer"
          />

          <span>{{ attachment?.name }}</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container class="!mx-[1rem]">
  <!-- RTE -->
  <div class="mb-4 !mt-[4rem]">
    <app-rich-textEditor
      [placeHolder]="'Health & Safety Management Plan.'"
      [label]="'Health & Safety Management Plan.'"
      [disable]="true"
      [richTextValue]="tendererResponse?.health_safety_plan"
    ></app-rich-textEditor>
    <div
      class="flex items-center"
      *ngIf="technicalHealthSafetyAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of technicalHealthSafetyAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                technicalHealthSafetyAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                technicalHealthSafetyAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Environmental Sustainability Plan -->
  <div>
    <label class="!pt-[3px] !mb-[5rem]">
      Environmental Sustainability Plan
    </label>
    <div class="p-5 !pl-0 !pt-[5px] !pb-[5px]">
      <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
        <div
          class="radio-group !pb-0 border !pt-0 items-center !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
        >
          <p>Do you have a Health and Safety Policy in place?</p>
          <mat-radio-group
            aria-label="Health and Safety Policy"
            class="flex gap-4 justify-center"
            [disabled]="true"
            [value]="tendererResponse?.has_environmental_plan"
          >
            <mat-radio-button [value]="1">Yes</mat-radio-button>
            <mat-radio-button [value]="0">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div
      class="p-0 mb-[1rem] flex relative !mt-5"
      *ngIf="tendererResponse?.has_environmental_plan === 1"
    >
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem] w-full">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Detail</mat-label>
          <textarea
            matInput
            [value]="
              tendererResponse?.environmental_plan_description
                ? tendererResponse?.environmental_plan_description
                : ''
            "
            readonly
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="flex items-center" *ngIf="environmentalSustainabilityPlanAttachments?.length > 0">
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of environmentalSustainabilityPlanAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
              environmentalSustainabilityPlanAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
              environmentalSustainabilityPlanAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Technical Deviations/Clarifications -->
  <div>
    <label class="!pt-[3px] !pb-[5rem]">
      Technical Deviations/Clarifications
    </label>
    <div class="p-5 !pl-0 !pt-[5px] !pb-[5px]">
      <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
        <div
          class="radio-group !pb-0 border !pt-0 items-center !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
        >
          <p>Do you have technical deviations/clarifications?</p>
          <mat-radio-group
            aria-label="Health and Safety Policy"
            class="flex gap-4 justify-center"
            [disabled]="true"
            [value]="tendererResponse?.has_technical_deviations"
          >
            <mat-radio-button [value]="1">Yes</mat-radio-button>
            <mat-radio-button [value]="0">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <div
      class="p-0 mb-[1rem] flex relative !mt-5"
      *ngIf="tendererResponse?.has_technical_deviations === 1"
    >
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem] w-full">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Detail</mat-label>
          <textarea
            matInput
            [value]="
              tendererResponse?.technical_deviations_description
                ? tendererResponse?.technical_deviations_description
                : ''
            "
            readonly
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="flex items-center" *ngIf="technicalDeviationsClarificationsAttachments?.length > 0">
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of technicalDeviationsClarificationsAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
              technicalDeviationsClarificationsAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
              technicalDeviationsClarificationsAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Commercial Submission -->
  <div>
    <h3
      class="header !text-[18px] !text-[#21252A] font-semibold !pt-0 !ml-0 !mt-5"
    >
      Commercial Submission
    </h3>
    <!-- <label class="!pt-[3px] !font-medium !mb-[1rem]"> Price Breakdown </label>

    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 !mt-5">
      <div class="p-0">
        <div class="rounded p-0 !pb-0 !pt-0 mr-[66px]">
          <mat-form-field class="!w-[100%]" appearance="outline">
            <mat-label> Title </mat-label>
            <input
              matInput
              [value]="tendererResponse?.price_breakdown_title"
              readonly
              placeholder="Title"
            />
          </mat-form-field>
        </div>
      </div>
    </div> -->

    <div class="p-0 mb-[1rem] flex relative">
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem] w-full">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea
            [value]="tendererResponse?.price_breakdown_description"
            matInput
            readonly
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div
      class="flex items-center"
      *ngIf="commercialPriceBreakdownAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of commercialPriceBreakdownAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                commercialPriceBreakdownAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                commercialPriceBreakdownAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Financial Stability -->
  <div>
    <div
      class="header h-[55px] flex justify-start items-center !mt-5 mb-[18px]"
    >
      <label class="!m-0">Financial Stability</label>
    </div>
    <div class="p-0 mb-[1rem]">
      <div class="rounded p-0 !pb-0 !pt-0 mr-[4.125rem]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Financial Stability </mat-label>
          <textarea
            [value]="tendererResponse?.financial_stability_description"
            matInput
            readonly
            placeholder="Financial Stability"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div
      class="flex items-center"
      *ngIf="financialStabilityAttachments?.length > 0"
    >
      <div
        class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
      >
        Attachments
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of financialStabilityAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                financialStabilityAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                financialStabilityAttachments
            }"
            #downloadTendererDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadTendererDocument(
                $event,
                downloadTendererDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
            <img
              [src]="getFileIcon(attachment)"
              alt="File Preview"
              class="object-cover w-5 h-5 cursor-pointer"
            />

            <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Contractual Comments -->
  <div>
    <div class="mb-4">
      <app-rich-textEditor
        [placeHolder]="'Contractual Comments'"
        [label]="'Contractual Comments'"
        [disable]="true"
        [richTextValue]="tendererResponse?.contractual_comments"
      ></app-rich-textEditor>
    </div>
  </div>
  <!-- Proof of Insurance -->
  <div>
    <label class="!pt-[3px] !font-medium mb-[1rem]"> Proof of Insurance </label>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">
      <div
        class="flex items-center"
        *ngIf="proofOfInsuranceAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
        >
          Attachments
          <!-- Download attachment -->
          <div class="flex flex-col space-y-2">
            <a
              *ngFor="let attachment of proofOfInsuranceAttachments"
              class="flex items-center space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  proofOfInsuranceAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  proofOfInsuranceAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />

              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Performance Bond/Guarantee -->
  <div>
    <label class="!pt-[3px] !font-medium mb-[1rem]">
      Performance Bond/Guarantee
    </label>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">
      <div
        class="flex items-center"
        *ngIf="performanceBondsAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
        >
          Attachments
          <!-- Download attachment -->
          <div class="flex flex-col space-y-2">
            <a
              *ngFor="let attachment of performanceBondsAttachments"
              class="flex items-center space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  performanceBondsAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  performanceBondsAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />

              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Conclusion -->
  <div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Conclusion</p>
    </div>
    <p class="breif-value text-justify">
      We welcome your participation in this tender process and look forward to
      receiving your proposal. Should you require any further information or
      Clarification (NEW SYSTEM REQUIRED), please do not hesitate to contact us
      as indicated in Section 4. Yours sincerely,
    </p>
    <p class="breif-value text-justify">
      {{ tendererResponse?.tenderer_name }}<br />
      {{ tendererResponse?.tenderer_position }}<br />
      {{ tendererResponse?.tenderer_company_name }}<br />
      {{ tendererResponse?.tenderer_contact_information }}
    </p>
  </div>
  <!-- Disclaimer -->
  <div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Disclaimer</p>
    </div>
    <p class="breif-value text-justify">The Client reserves the right to:</p>
    <ul class="breif-value text-justify !pl-10">
      <li>Amend or withdraw this RFP at any stage without liability.</li>
      <li>Reject any or all tenders without giving reasons.</li>
      <li>
        Award the contract in part or not at all, depending on the Clients best
        interests.
      </li>
      <li>
        Disqualify any tenderer found to have engaged in corrupt or fraudulent
        practices.
      </li>
    </ul>
  </div>

  <!-- Submit Response -->
  <ng-container *ngIf="isShowRfpSubmitBtn">
    <div class="flex justify-end mb-[3rem]">
      <button
        type="button"
        (click)="submitTendererResponse()"
        class="submit-button"
        [disabled]="btnDisable ? true : false"
        [ngClass]="
          btnDisable ? '!bg-[#868E96] !border-none cursor-no-drop' : ''
        "
      >
        Submit {{ labels.rfpMode }}
      </button>
    </div>
  </ng-container>
</ng-container>
